import {observer} from "mobx-react";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import {FONT_COLOR} from "../../../../components/fonts/font-props";
import AHref from "../../../ahref/ahref";
import DateTimeV2, {DATETIME_VIEW} from "../../../datetime-v2/datetime-v2";
import { useDateTimeFormattingParams } from "../../../../hooks/use-datetime-formatting-params";

interface ILastReportTitleProps {
    dateString: string,
    link: string
}

const LastReportTitle: React.FC<ILastReportTitleProps> = observer(({ dateString, link }) => {
    const dateTimeParams = useDateTimeFormattingParams();

    return (
        <AHref download href={link} target="_blank">
            <FontBody1 color={FONT_COLOR.ACCENT1}>
                Last report <DateTimeV2 {...dateTimeParams} dateTimeView={DATETIME_VIEW.FULL} utcDateString={dateString} />
            </FontBody1>
        </AHref>
    );
});

export default LastReportTitle;
